import { render, staticRenderFns } from "./lista-buscador-filtros-activos.vue?vue&type=template&id=a7a95d5a&scoped=true&"
import script from "./lista-buscador-filtros-activos.vue?vue&type=script&lang=ts&"
export * from "./lista-buscador-filtros-activos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a95d5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VChipGroup,VIcon})
